module.exports = __webpack_public_path__ + "img/tutorial_six_en.7fab8023.png";